module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADfSURBVFiF7dhLDoIwEAbgGcDEldFDEM9CuIs3QCOewMugZ1HvQOLK+Oi4MJoW6ZiYYmL4v107UzoLoA8iAOgX9gUm5UXcTM7rIqmezXF5njHxOnA9pp4P4rZAFHiizqDQ0BJvhDnXBjJHByJScwAAesC71o9Wp7TZdyyGey0egj2HzfvDjyXeOR2PBeD1kEiirItNCRFhU/ITf1Oo/x01t6k60JgtEak5AAA94L+AWF6zZl+9SDZaPAR7DptyCpXKbbunUmGTYlPSAoWG5v2YSOQ9xixqPEhFLJ+TAOBrdzbzMkTp4tn3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cd.png
// module id = OvMc
// module chunks = 3